import { Link, useLocation } from 'react-router-dom';
import { BriefcaseBusiness, Home, Search, UserRound, Wallet } from 'lucide-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import './CreatorBottomNav.scss';

const CreatorBottomNav = () => {
  const { currentUser, isAuthenticated } = useAuth();
  const { t } = useTranslation('common');
  const location = useLocation();

  if (!isAuthenticated || currentUser?.user_type !== 'creator') {
    return null;
  }

  const invitedOfferIds = currentUser?.creator_profile?.invited_offer_ids || [];
  const isApprovedCreator = currentUser?.creator_profile?.admin_verified
    && currentUser?.creator_profile?.verification_status === 'approved';
  const isRestrictedInvitedCreator = !isApprovedCreator
    && (
      currentUser?.creator_profile?.has_invited_access
      || invitedOfferIds.length > 0
      || currentUser?.creator_profile?.invited_collab
    );

  const primaryCollabPath = isRestrictedInvitedCreator ? '/creator/invited' : '/creator/applications';
  const items = isRestrictedInvitedCreator
    ? [
        { to: '/creator/invited', label: t('pwa.nav_collabs', 'Mis Collabs'), icon: BriefcaseBusiness },
        { to: '/creator/wallet', label: t('navbar.wallet', 'Ganancias'), icon: Wallet },
        { to: currentUser?.username ? `/profile/${currentUser.username}` : '/profile', label: t('pwa.nav_profile', 'Perfil'), icon: UserRound },
      ]
    : [
        { to: '/dashboard', label: t('pwa.nav_home', 'Inicio'), icon: Home },
        { to: '/creator/feed', label: t('pwa.nav_explore', 'Explorar'), icon: Search },
        { to: '/creator/applications', label: t('pwa.nav_collabs', 'Mis Collabs'), icon: BriefcaseBusiness },
        { to: '/creator/wallet', label: t('navbar.wallet', 'Ganancias'), icon: Wallet },
        { to: currentUser?.username ? `/profile/${currentUser.username}` : '/profile', label: t('pwa.nav_profile', 'Perfil'), icon: UserRound },
      ];

  return (
    <nav className="creator-bottom-nav" aria-label={t('pwa.creator_nav_label')}>
      {items.map(({ to, label, icon: Icon }) => {
        const isActive = location.pathname === to
          || (to === primaryCollabPath && (
            location.pathname.startsWith('/creator/applications')
            || location.pathname.startsWith('/creator/invited')
            || location.pathname.startsWith('/creator/collabs')
            || location.pathname.startsWith('/creator/offers')
          ))
          || (to === '/creator/wallet' && location.pathname.startsWith('/creator/wallet'));

        return (
          <Link
            key={to}
            to={to}
            className={clsx('creator-bottom-nav__item', isActive && 'is-active')}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={20} aria-hidden="true" />
            <span>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default CreatorBottomNav;
